import { render, staticRenderFns } from "./SubjectPoolIndex.vue?vue&type=template&id=0dc58cd0"
import script from "./SubjectPoolIndex.vue?vue&type=script&lang=js"
export * from "./SubjectPoolIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports